import { EditOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import React from 'react';

type TableActionsProps = {
  onEditClick: () => void;
};

export const TableActions = ({ onEditClick }: TableActionsProps): JSX.Element => {
  return (
    <div className="flex justify-center items-center text-xl sm:text-base">
      <Popover content="Preview/Edit" trigger="hover">
        <EditOutlined
          className="inline-flex items-center justify-center rounded-md cursor-pointer p-1 sm:p-0 hover:bg-gray-100"
          style={{ color: '#438EF7', fontSize: 'inherit' }}
          onClick={onEditClick}
        />
      </Popover>
    </div>
  );
};
